import type { SVGProps } from 'react'
import * as React from 'react'

const iconRemoveOverride = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={15} height={15} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3643_14944)">
      <path d="M0.625 2.5V6.25H4.375" stroke="#78787A" strokeWidth={1.3} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.19375 9.37503C2.599 10.5253 3.36708 11.5126 4.38229 12.1884C5.39749 12.8641 6.6048 13.1916 7.82232 13.1216C9.03984 13.0515 10.2016 12.5876 11.1326 11.7999C12.0635 11.0121 12.7133 9.94314 12.9839 8.75401C13.2545 7.56487 13.1313 6.32 12.6329 5.20697C12.1345 4.09393 11.2878 3.17303 10.2205 2.58301C9.15321 1.99299 7.92306 1.76582 6.71542 1.93573C5.50778 2.10564 4.38807 2.66342 3.525 3.52503L0.625 6.25003"
        stroke="#78787A"
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3643_14944">
        <rect width={15} height={15} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default iconRemoveOverride
